import { Component, ViewChild, OnInit, OnDestroy, Input, Output, EventEmitter, Injector } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { Store } from '@ngrx/store';
import { Pagination, TenantRoleLoginEPService } from 'blg-akaun-ts-lib';
import { PermissionFacade } from '../../../../../../modules/permission/facades/permission.facade';
import { gridOptionsServerSide, pageFiltering, pageSorting, serverSideClear } from '../../../../../../listing.utils';
import { PaginationComponent } from '../../../../../../utilities/pagination/pagination.component';
import { ViewColumnComponent } from '../../../../../../view-column.component';
import { AppConfig } from '../../../../../../visa';
import { Observable, of } from 'rxjs';
import { SubSink } from 'subsink2';
import { PermissionStates } from '../../../../permission-controller/root';
import { UserPermSelectors } from '../../../../../../modules/permission/user-permissions-controller/selectors';
import { filter, switchMap } from 'rxjs/operators';
import { UserPermActions } from '../../../../../../modules/permission/user-permissions-controller/actions';
import { SearchQueryModel } from '../../../../../../models/query.model';
import { UserPermRoleSearchModel } from '../../../../../../models/advanced-search-models/user-permissions-role-listing-search.model';
import { TranslateService } from "@ngx-translate/core";
// interface LocalState {
//     deactivateList: boolean;
//     selectedIndex: number;
// }

@Component({
    selector: 'app-user-permission-role',
    templateUrl: './user-permission-role.component.html',
    styleUrls: ['./user-permission-role.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
    // providers: [ComponentStore]
})

export class UserPermissionRoleComponent extends ViewColumnComponent implements OnInit, OnDestroy {

    @ViewChild(MatTabGroup, {static:true}) matTab: MatTabGroup;

    @ViewChild(PaginationComponent, {static: false})
    private paginationComponent: PaginationComponent;

    @Input() localState: any;
    @Output() roleEntity = new EventEmitter();

    // protected readonly index = 1;
    // private localState: LocalState;

    // info. about previous local states
    // prevIndex: number;
    // private prevLocalState: any;

    // initialise local states
    // readonly localState$ = this.viewColFacade.selectLocalState(this.index);
    // readonly selectedIndex$ = this.componentStore.select(state => (state.localState.selectedIndex));

    toggleColumn$: Observable<boolean>;
    searchModel = UserPermRoleSearchModel;

    // api visa
    apiVisa = AppConfig.apiVisa;

    // initial ag grid state
    gridApi;
    gridOptions = gridOptionsServerSide;
    columnsDefs;
    rowSelection = 'single';
    appletGuid = sessionStorage.getItem('appletGuid');
    userGuid: string;

    // subSink is to ensure all subscribe calls are unsubscribed to once the component is destroyed
    private subSink = new SubSink;

    //translation variable
    role_code_text: string;
    role_name_text: string;

    constructor(
        // private fb: FormBuilder,
        private store: Store<PermissionStates>,
        private viewColFacade: PermissionFacade,
        // private readonly componentStore: ComponentStore<{localState: LocalState}>,
        // private tenantRoleService: TenantRoleService,
        private tenantRoleService: TenantRoleLoginEPService,
        private injector: Injector
      ) {
        super();
        const translateService = this.injector.get(TranslateService, null);
        if (translateService) {
          translateService.get('labels').subscribe(res => {
            this.role_code_text = res.role_code;
            this.role_name_text = res.role_name;
          });
        } else {
          // Fallback if translation service is unavailable
          this.role_code_text = 'Role Code';
          this.role_name_text = 'Role Name';
        }
      }

    /**
     * Lifecycle method: Called when component is first initialised.
     */
    ngOnInit(): void {
        // initial configurations for toggle column and local state
        // this.toggleColumn$ = this.viewColFacade.toggleColumn$;
        // this.subSink.sink = this.localState$.subscribe( a => {
        //     this.localState = a;
        //     this.componentStore.setState( {localState: a} );
        // });

        this.columnsDefs = [
            {
                headerName: this.role_code_text,
                field: 'app_mst_role.code',
                cellStyle: {textAlign: 'left'}
            },
            {
                headerName: this.role_name_text,
                field: 'app_mst_role.name',
                cellStyle: {textAlign: 'left'}
            }
        ]
    }

    /**
     * This function is called when AG grid is first initialised and initially
     * set the datasource of the grid.
     *
     * @param params : grid parameters
     */
    onGridReady(params) {
        this.gridApi = params.api;
        this.gridApi.closeToolPanel();

        this.subSink.sink = this.store.select(UserPermSelectors.selectSelectedUser).subscribe(user => {
            console.log("user",user);
            if(user) {
                this.userGuid = user.userModel.bl_applet_login_subject_link.app_login_guid.toString();
                console.log("UserGuid: ",this.userGuid);
                const datasource = this.getDatasource();
                this.gridApi.setServerSideDatasource(datasource);
            }
        })
    }

    /**
     * Returns the datasource for the AG grid.
     *
     * @param conditionalCriteria : any custom criteria to search for in the API
     * @returns the datasource
     */
    getDatasource(conditionalCriteria?){
        let offset = 0;
        let limit = this.paginationComponent.rowPerPage;

        if(!conditionalCriteria) {
            conditionalCriteria = [
                { columnName: 'calcTotalRecords', operator: '=', value: 'true' },
                { columnName: 'app_subject_guid', operator: '=', value: this.userGuid }
            ]
        }

        console.log("conditionalCriteria 1: ", conditionalCriteria);

        return {
            getRows: grid => {

                // dispatch action for loading roles
                this.store.dispatch(UserPermActions.loadRolesInit({request: grid.request}));
                const sortModel = grid.request.sortModel;
                const filterModel = grid.request.filterModel;
                const sortOn = pageSorting(sortModel);
                const filter = pageFiltering(filterModel);

                // only change offset and limit if no filterModel or sortModel is present
                if (Object.keys(filterModel).length == 0 && sortModel.length == 0) {
                    offset = grid.request.startRow;
                    limit = grid.request.endRow - offset;
                }

                console.log("conditionalCriteria 2 :", conditionalCriteria);
                const pagination = new Pagination(offset, limit, conditionalCriteria);
                this.subSink.sink = this.tenantRoleService.getByGuidCriteria(pagination, this.apiVisa, this.appletGuid.toString())
                .subscribe(a => {
                    console.log("a", a);
                    // put data into the grid
                    const data = sortOn(a.data).filter(entity => filter.by(entity));
                    const totalRecords = filter.isFiltering ? a.totalRecords : data.length;

                    // force pagination to go to first page if filter is applied
                    if (this.paginationComponent.currentPage > this.paginationComponent.totalPage.value) { this.paginationComponent.firstPage() }

                    grid.successCallback(data, totalRecords);
                    this.store.dispatch(UserPermActions.loadRolesSuccess({totalRecords: a.totalRecords}));
                  }, err => {
                    grid.failCallback();
                    this.store.dispatch(UserPermActions.loadRolesFailure({error: err.message}));
                })
            }
        }
    }

  /**
   * This function is called every time the user searches something in the
   * search bar.
   *
   * @param e : the search model
   */
  /**
   * Runs the search bar's query against the roles listing's own endpoint.
   *
   * Replaces the raw SQL that <app-advanced-search> built from
   * UserPermRoleSearchModel and posted to SubQueryService (a SELECT over
   * app_mst_role). The search bar is now <app-advanced-search-general>, which
   * emits the keyword and the form value instead of SQL.
   *
   * GET iam/roles/applet-login-ep/{applet}/query -> RoleUow ->
   * generateWhereClauseByCriteria honours `search_word` (bound ILIKE over
   * namespace, name, role_type, description and code), `code_like` and
   * `name_like`, and defaults to `status != 'DELETED'`.
   *
   * getDatasource only applies its defaults when called with no argument, so the
   * calcTotalRecords and app_subject_guid scoping is re-seeded here -- otherwise
   * a search would list every role rather than this user's.
   *
   * Behaviour note: the keyword also matches namespace, role_type and
   * description, so the basic search is broader than the old code/name pair.
   */
  onSearch(e: SearchQueryModel) {
    const datasource = this.getDatasource(this.buildSearchCriteria(e));
    this.gridApi.setServerSideDatasource(datasource);
  }

  /**
   * Criteria for the emitted search, or undefined when it is empty so the
   * listing falls back to its default criteria.
   */
  buildSearchCriteria(e: SearchQueryModel) {
    if (!e || e.isEmpty) {
      return undefined;
    }
    const scope = [
      { columnName: 'calcTotalRecords', operator: '=', value: 'true' },
      { columnName: 'app_subject_guid', operator: '=', value: this.userGuid }
    ];
    if (e.keyword) {
      return scope.concat([
        { columnName: 'search_word', operator: '=', value: e.keyword.trim() }
      ]);
    }
    const query: any = e.queryString || {};
    return scope.concat(
      [
        { columnName: 'code_like', operator: '=', value: query.code },
        { columnName: 'name_like', operator: '=', value: query.name }
      ].filter(condition => condition.value)
    );
  }

    // /**
  //  * This function is called every time the user clicks on a row in the
  //  * AG grid.
  //  *
  //  * @param entity : the entity on the AG grid that was clicked on
  //  */
  onRowClicked(entity: any) {
    this.roleEntity.emit(entity);
  }


  /**
   * Lifecycle method: Called when component is destroyed.
   */
  ngOnDestroy() {
    this.subSink.unsubscribe();
  }

}
